import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'

import { FundManagementService } from './fund-management.service'
import {
  AccordionData,
  Advisor,
  Corporation,
  FundManagement,
  ManagementDetails,
} from './fundManagement.model'
@Component({
  selector: 'fund-management',
  templateUrl: './fund-management.component.html',
  styleUrls: ['./fund-management.component.scss'],
})
export class FundManagementComponent implements OnInit, OnDestroy {
  ticker: string
  fundManagementModel: FundManagement
  stringModel: string
  fundManagementSubscription: Subscription
  managementDetails: ManagementDetails = new ManagementDetails()
  corporationPlaceholders: Corporation[] = []
  newString?: string
  currentYear: number = new Date().getFullYear()
  accordianModel: AccordionData[] = []
  fundVideoList = {
    vgwlx: 'IKz6h56DU7I',
    vidgx: 'IKz6h56DU7I',
    vgelx: 'IKz6h56DU7I',
    vgenx: 'IKz6h56DU7I',
    vgpmx: 'IKz6h56DU7I',
    vesgx: 'IKz6h56DU7I',
    veigx: 'IKz6h56DU7I',
    vgyax: 'IKz6h56DU7I',
    vgwix: 'IKz6h56DU7I',
    vgwax: 'IKz6h56DU7I',
    vfijx: 'IKz6h56DU7I',
    vfiix: 'IKz6h56DU7I',
    vzicx: 'IKz6h56DU7I',
    vwicx: 'IKz6h56DU7I',
    vwiax: 'IKz6h56DU7I',
    vwinx: 'IKz6h56DU7I',
    vwenx: 'IKz6h56DU7I',
    vwelx: 'IKz6h56DU7I',
    vdig: 'D_x-o8LuoOY',
    vusg: 'D_x-o8LuoOY',
    vusv: 'D_x-o8LuoOY',
  }
  //AEM content variables
  portfolioAdvisoryStructure: AEMChunk
  aemContentSub: Subscription

  constructor(
    private readonly fundManagementService: FundManagementService,
    private readonly centralContentService: CentralContentService,
  ) {}
  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
    throw new Error('Method not implemented.')
  }

  checkURLTicker() {
    const url = window.location.href
    const urlSplit = url.split('/')
    const ticker = urlSplit[urlSplit.length - 1].split('#')[0].split('?')[0]
    return ticker
  }

  ngOnInit() {
    this.ticker = this.checkURLTicker()
    this.fundManagementSubscription = this.fundManagementService
      .getModelData()
      /* eslint max-statements: [2, 70] */
      /*eslint complexity: [2, 30] */
      .subscribe((model) => {
        this.fundManagementModel = model
        this.managementDetails.managementCompanies = []
        let companyList =
          this.fundManagementModel.firmAdvisor.split('</ul> <p><strong>')
        for (let i in companyList) {
          this.corporationPlaceholders.push(new Corporation())
          let infoArray = companyList[i].split('</strong></p>')
          this.corporationPlaceholders[i].name = infoArray[0]
            .split('<p><strong>')
            .join('')
          if (infoArray[1] !== '<p><strong><em>Firm Description</em>') {
            if (infoArray[1].includes('Firm Description')) {
              this.corporationPlaceholders[i].description =
                infoArray[1]
                  .replace('</p><p><strong><em>Firm Description</em>', '')
                  .replace('<p>', '') +
                '<br><br><br>' +
                infoArray[2]
                  .replace(
                    '</p><p><strong><em>Investment Manager Biographies</em>',
                    '',
                  )
                  .replace('<p>', '')
            } else {
              this.corporationPlaceholders[i].description = infoArray[1]
            }
          } else {
            this.corporationPlaceholders[i].description = infoArray[2]
              .replace(
                '</p><p><strong><em>Investment Manager Biographies</em>',
                '',
              )
              .replace('<p>', '')
          }
          let biographiesArray = infoArray
            .at(-1)
            .split('<p>')
            .filter((element) => element.trim() !== '')
          function removeSpacesBetweenTags(array) {
            return array.map((element) => element.replace(/\s+(?=<)/g, ''))
          }
          let advisorList = removeSpacesBetweenTags(biographiesArray)
          this.corporationPlaceholders[i].advisors = []
          for (let j in advisorList) {
            this.corporationPlaceholders[i].advisors.push(new Advisor())
            let advisorArray = advisorList[j].split('</li><li>')
            let advisorNameCreds = advisorArray[0]
            this.corporationPlaceholders[i].advisors[j].name = advisorNameCreds
              .split(',')[0]
              .split('</p><ul><li>')[0]
              .replace('<p>', '')
            if (advisorArray[0].split(',').length > 2) {
              for (let k = 1; k < advisorArray[0].split(',').length; k++) {
                if (k == 1) {
                  this.corporationPlaceholders[i].advisors[j].credentials =
                    advisorNameCreds.split(',')[k].replace('</p><ul><li>', ' ')
                } else {
                  this.corporationPlaceholders[i].advisors[j].credentials =
                    this.corporationPlaceholders[i].advisors[j].credentials +
                    ', ' +
                    advisorNameCreds.split(',')[k].replace('</p><ul><li>', ' ')
                }
              }
            } else {
              if (advisorNameCreds.split(',').length < 2) {
                this.corporationPlaceholders[i].advisors[j].credentials =
                  advisorNameCreds.split('</p><ul><li>')[1]
              } else {
                this.corporationPlaceholders[i].advisors[j].credentials =
                  advisorNameCreds.split(',')[1].replace('</p><ul><li>', ', ')
              }
            }
            this.corporationPlaceholders[i].advisors[j].description =
              advisorArray
                .join(' ')
                .replace(advisorArray[0], '')
                .replace('</li>', '')
                .replace('</ul>', '')
          }
        }
        this.managementDetails.managementCompanies =
          this.corporationPlaceholders
      })

    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  parseAEMContent(content) {
    const isFundW502 = this.ticker.toUpperCase() === 'W502'
    const W502Text =
      '<p>The portfolio does not employ an investment advisor.</p>'

    this.portfolioAdvisoryStructure = isFundW502
      ? { contentValue: W502Text }
      : this.centralContentService.getContentByBody(
          'fund_definition_529_portoflio_advisor_structure',
          content,
        )
  }
}
